import { Entity } from "./UtilInfo";

export interface EnvironmentInfo extends Entity {
    title: string;
    url: string;
    order: number;
    environmentType: EnvironmentType;
}

export enum EnvironmentType {
    Unknown,
    Dev,
    QA,
    Demo,
    Prod
}

export type EnvironmentTypeLookup = { text: string; value: EnvironmentType | null };

export const environmentTypes: Array<EnvironmentTypeLookup> = [
    { text: 'Dev', value: EnvironmentType.Dev },
    { text: 'QA', value: EnvironmentType.QA },
    { text: 'Demo', value: EnvironmentType.Demo },
    { text: 'Prod', value: EnvironmentType.Prod }
];

export const DefaultEnvironment: EnvironmentTypeLookup = { text: 'N/A', value: EnvironmentType.Unknown };


export const getEnvironmentTypeName = (environmentValue: EnvironmentType | undefined | null): string => {
    const environment: EnvironmentTypeLookup = getEnvironmentType(environmentValue);

    return environment.text || 'Unknown Environment Type';
};

export const getEnvironmentType = (environmentValue: EnvironmentType | undefined | null): EnvironmentTypeLookup => {
    if (environmentValue === undefined || environmentValue === null) {
        return DefaultEnvironment;
    }

    const environmentObject = environmentTypes.find((env) => env.value === environmentValue);
    return environmentObject ? environmentObject : DefaultEnvironment;
};